import { EReportTypes, ReportTypes } from "../report/routes/report_types";

export const REPORT_TYPES: ReportTypes = {
  [EReportTypes.FinanceReceiveBills]: {
    name: EReportTypes.FinanceReceiveBills,
    title: "Receive Bills",
    path: "/finance/receive-bills",
  },
  [EReportTypes.FinanceExportBills]: {
    name: EReportTypes.FinanceExportBills,
    title: "Export Bills",
    path: "/finance/export-bills",
  },
  [EReportTypes.FinanceExportedBills]: {
    name: EReportTypes.FinanceExportedBills,
    title: "Exported Bills",
    path: "/finance/exported-bills",
  },
  [EReportTypes.FinanceSalesOrders]: {
    name: EReportTypes.FinanceSalesOrders,
    title: "Sales Orders",
    path: "/finance/sales-orders",
  },
  [EReportTypes.FinanceDepositInvoices]: {
    name: EReportTypes.FinanceDepositInvoices,
    title: "Deposit Invoices",
    path: "/finance/deposit-invoices",
  },
  [EReportTypes.FinanceInvoices]: {
    name: EReportTypes.FinanceInvoices,
    title: "Invoices",
    path: "/finance/invoices",
  },
  [EReportTypes.FinanceExportedInvoices]: {
    name: EReportTypes.FinanceExportedInvoices,
    title: "Exported Invoices",
    path: "/finance/exported-invoices",
  },
  [EReportTypes.FinanceCreditMemos]: {
    name: EReportTypes.FinanceCreditMemos,
    title: "Credit Memos",
    path: "/finance/credit-memos",
  },
  [EReportTypes.FinancePodBills]: {
    name: EReportTypes.FinancePodBills,
    title: "Print on Demand Bills",
    path: "/finance/pod-bills",
    userFlags: ["POD_ENABLED"],
  },
  [EReportTypes.FinanceVendorCredits]: {
    name: EReportTypes.FinanceVendorCredits,
    title: "Vendor Credits",
    path: "/finance/vendor-credits",
  },
  [EReportTypes.FinanceRefunds]: {
    name: EReportTypes.FinanceRefunds,
    title: "Refunds",
    path: "/finance/refunds",
    userFlags: ["COMMONSKU-PAYMENTS-QBO-REFUNDS-UI"],
  },
};

const BILLING_REPORTS = [
  EReportTypes.FinanceReceiveBills,
  EReportTypes.FinanceExportBills,
  EReportTypes.FinanceExportedBills,
  EReportTypes.FinancePodBills,
  EReportTypes.FinanceVendorCredits,
];

const INVOICING_REPORTS = [
  EReportTypes.FinanceSalesOrders,
  EReportTypes.FinanceDepositInvoices,
  EReportTypes.FinanceInvoices,
  EReportTypes.FinanceExportedInvoices,
  EReportTypes.FinanceCreditMemos,
  EReportTypes.FinanceRefunds,
];

export function isBillingReport(report_type: string): boolean {
  return (BILLING_REPORTS as string[]).includes(report_type);
}

export function isInvoicingReport(report_type: string): boolean {
  return (INVOICING_REPORTS as string[]).includes(report_type);
}

export function isPodBillsReport(report_type: string): boolean {
  return EReportTypes.FinancePodBills === report_type;
}

export function getReportTabs(
  report_type: string,
  hasUserFlags: (flags: string[]) => boolean,
): (keyof typeof REPORT_TYPES)[] {
  let reports: (keyof typeof REPORT_TYPES)[] = [];

  if (isBillingReport(report_type)) {
    reports = BILLING_REPORTS;
  } else if (isInvoicingReport(report_type)) {
    reports = INVOICING_REPORTS;
  }

  return reports.filter((report_type) => {
    const flags = REPORT_TYPES[report_type]?.userFlags;
    return !flags || hasUserFlags(flags);
  });
}

export function getPageTitle(report_type: string): string {
  if (isBillingReport(report_type)) {
    return "Billing";
  } else if (isInvoicingReport(report_type)) {
    return "Invoicing";
  }
  return "";
}
